module.exports = __webpack_public_path__ + "front/img/10_8.16c26c57.png";